const listPointsBody = document.querySelector('#vote_result_card_top_last_voices');
// import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index) {

    return `
    
    <label class="reference-header" for="${item.id}" data-region-id="${item.id}" data-region-name="${item.name}">
        <div class="reference-column last_voices_column" >${index +1}</div>
        <div class="reference-column  last_voices_column" >${item.name}</div>
        <div class="reference-column last_voices_column">${item.value}</div>
        <div class="reference-column last_voices_column">*****${item.device}</div>
        <div class="reference-column last_voices_column">${item.timevoice}</div>

        
    </label>
`;


  },

  drawDataInContainer(enterprisesData) {
    let htmlBody = `
    <div class="reference-header">
        <div class="reference-column last_voices_column">№</div>
        <div class="reference-column last_voices_column">Название</div>
        <div class="reference-column last_voices_column">Оценка</div>
        <div class="reference-column last_voices_column">Устройство</div>
        <div class="reference-column last_voices_column">Время</div>
       
    </div>
    `;
    
    if(enterprisesData)
      enterprisesData.forEach((item, index) => htmlBody += this.getElement(item, index));

    listPointsBody.innerHTML = htmlBody;
  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
